import "../styles/loader.css";
import LoaderIcon from "./LoaderIcon";

export default function Loader() {
  return (
    <div className="loader-screen">
      <LoaderIcon size={56} />
    </div>
  );
}
